import { combineReducers } from "redux";
// import adminReducer from "../views/Admin/Admin.reducer";
// import rolesReducer from "../views/AdminStaff/permissions/permissions.reducer";
import errorReducer from "./shared/error/error.reducer";
// import settingsReducer from ".././views/Settings/settings.reducer";
// Dashboard reducer removed - now using RTK Query (dashboardApi)
// import ContentManagementReducer from "views/ContentManagment/cms.reducer";
// import CategoryReducer from "views/Categories/categories.reducer";
// import documentsReducer from "views/Douments/documents.reducer";
// import TeamReducer from "views/TeamMembers/teamMembers.reducer";
// import galleryReducer from "views/Gallery/gallery.reducer";
// import eventReducer from "views/Events/event.reducer";
// import sliderReducer from "views/Slider/slider.reducer";
// import aboutReducer from "views/About/about.reducer";
import { baseApi } from "./api/baseApi";

export default combineReducers({
//   admin: adminReducer,
//   role: rolesReducer,
  error: errorReducer,
//   settings: settingsReducer,
//   about: aboutReducer,
  // dashboard removed - using RTK Query instead
//   content: ContentManagementReducer,
//   categories: CategoryReducer,
//   documents: documentsReducer,
//   gallery: galleryReducer,
//   event: eventReducer,
//   team: TeamReducer,
//   slider: sliderReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});
